import React from 'react';
import { Clock, TrendingUp, Search } from 'lucide-react';
import { CATEGORIES } from '../lib/utils';

const LABELS = {
  it: { recent: 'Le tue ricerche', popular: 'Più cercate', trending: 'Di tendenza ora', in: 'in' },
  de: { recent: 'Deine Suchen', popular: 'Beliebte Suchen', trending: 'Gerade im Trend', in: 'in' },
  fr: { recent: 'Tes recherches', popular: 'Les plus recherchées', trending: 'Tendances du moment', in: 'dans' },
  en: { recent: 'Your searches', popular: 'Popular searches', trending: 'Trending now', in: 'in' },
};
const ICONS = { recent: Clock, trending: TrendingUp, popular: Search };

const catLabel = (id, lang) => {
  const cat = id && id !== 'all' && CATEGORIES.find((c) => c.id === id);
  return cat ? cat.label[lang] || cat.label.it : null;
};

const Highlight = ({ text, query }) => {
  const i = query ? text.toLowerCase().indexOf(query.toLowerCase()) : -1;
  if (i < 0) return <span>{text}</span>;
  return (
    <span>
      {text.slice(0, i)}
      <span className="font-semibold text-foreground">{text.slice(i, i + query.length)}</span>
      {text.slice(i + query.length)}
    </span>
  );
};

export const SearchSuggestions = ({ ac, lang, testid = 'search', className = '' }) => {
  if (!ac.open) return null;
  const L = LABELS[lang] || LABELS.it;
  let lastKind = null;
  return (
    <div
      role="listbox"
      data-testid={`${testid}-suggestions`}
      className={`absolute left-0 right-0 top-full mt-2 z-[60] rounded-2xl border border-border/70 bg-background shadow-2xl shadow-black/10 py-2 text-left animate-in fade-in slide-in-from-top-1 duration-150 ${className}`}
      onMouseDown={(e) => e.preventDefault()}
    >
      {ac.items.map((item, idx) => {
        const Icon = ICONS[item.kind];
        const header = item.kind !== lastKind ? L[item.kind] : null;
        lastKind = item.kind;
        return (
          <React.Fragment key={`${item.kind}:${item.keyword}`}>
            {header && (
              <div className="px-4 pt-2 pb-1 text-[11px] font-medium uppercase tracking-wider text-muted-foreground/80">
                {header}
              </div>
            )}
            <button
              type="button"
              role="option"
              aria-selected={idx === ac.active}
              data-testid={`${testid}-suggestion-${idx}`}
              onMouseEnter={() => ac.setActive(idx)}
              onClick={() => ac.pick(item.keyword)}
              className={`w-full flex items-center gap-3 px-4 py-2 text-sm text-muted-foreground transition-colors ${idx === ac.active ? 'bg-muted' : 'hover:bg-muted/60'}`}
            >
              <Icon size={14} className={item.kind === 'trending' ? 'text-orange-500 shrink-0' : 'shrink-0 opacity-70'} />
              <span className="flex-1 truncate text-left">
                <Highlight text={item.keyword} query={ac.query} />
              </span>
              {catLabel(item.category, lang) && (
                <span
                  className="shrink-0 text-xs text-muted-foreground/80"
                  data-testid={`${testid}-suggestion-${idx}-category`}
                >
                  {L.in} <span className="text-primary/80 font-medium">{catLabel(item.category, lang)}</span>
                </span>
              )}
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
};
